import { FaTwitter, FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa";
import siteConfig from "../data/siteConfig";
import Reveal from "./Reveal";

const ICONS = {
  Twitter: FaTwitter,
  LinkedIn: FaLinkedin,
  GitHub: FaGithub,
  Instagram: FaInstagram,
};

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-base-light px-6 md:px-12 lg:px-24 pt-16 pb-8 overflow-hidden">
      {/* thin animated gradient line at the very top of the footer */}
      <div className="absolute top-0 left-0 right-0 h-px bg-brand-gradient bg-200 animate-gradient-shift" />

      <Reveal>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <a href="#home" className="flex items-center gap-2 group">
              <img
                src="/media/Logo.png"
                alt="Winrevo"
                className="h-14"
              />
            </a>
            <p className="text-sm text-slate-400 max-w-xs">
              {siteConfig.tagline}
            </p>
          </div>

          {siteConfig.footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-slate-400 hover:text-teal transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 pt-6">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.
        </p>
        <div className="flex items-center gap-4">
          {siteConfig.socials.map((s) => {
            const Icon = ICONS[s.name];
            return (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noreferrer"
                aria-label={s.name}
                className="w-9 h-9 rounded-full glass flex items-center justify-center text-slate-400 hover:text-teal hover:border-teal/40 transition-colors"
              >
                {Icon && <Icon size={14} />}
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
}
